import { cn } from '@/renderer/lib/utils';
import React from 'react';
import { APP_VERSION } from 'utils/constants';
import { AppLogo } from '../common/AppLogo';

interface AppVersionWrapperProps {
  className?: string;
  hideVersion?: boolean;
  hideLogo?: boolean;
}

export const AppVersionWrapper: React.FC<AppVersionWrapperProps> = ({
  className,
  hideVersion = false,
  hideLogo = false,
}) => {
  return (
    <div
      className={cn(
        'whitespace-nowrap text-sm font-medium text-gray-900 flex items-center gap-2',
        className,
      )}
    >
      {!hideLogo && <AppLogo size={20} />}
      smartPOSCloud{' '}
      {!hideVersion && (
        <span className={cn('text-gray-500', className, 'text-xs font-normal')}>
          v{APP_VERSION}
        </span>
      )}
    </div>
  );
};
